/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ItemType } from './';
import {
    ItemTypeFromJSON,
    ItemTypeFromJSONTyped,
    ItemTypeToJSON,
} from './';
import type { PortfolioPhoto } from './';
import {
    PortfolioPhotoFromJSON,
    PortfolioPhotoFromJSONTyped,
    PortfolioPhotoToJSON,
} from './';
import type { PortfolioVideo } from './';
import {
    PortfolioVideoFromJSON,
    PortfolioVideoFromJSONTyped,
    PortfolioVideoToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioItem
 */
export interface PortfolioItem {
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    profileId?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioItem
     */
    index?: number;
    /**
     * 
     * @type {ItemType}
     * @memberof PortfolioItem
     */
    type: ItemType;
}

/**
 * Check if a given object implements the PortfolioItem interface.
 */
export function instanceOfPortfolioItem(value: object): value is PortfolioItem {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PortfolioItemFromJSON(json: any): PortfolioItem {
    return PortfolioItemFromJSONTyped(json, false);
}

export function PortfolioItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioItem {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'PHOTO') {
            return PortfolioPhotoFromJSONTyped(json, true);
        }
        if (json['type'] === 'VIDEO') {
            return PortfolioVideoFromJSONTyped(json, true);
        }
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'index': json['index'] == null ? undefined : json['index'],
        'type': ItemTypeFromJSON(json['type']),
    };
}

export function PortfolioItemToJSON(value?: PortfolioItem | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'PHOTO') {
            return PortfolioPhotoToJSON(value as PortfolioPhoto);
        }
        if (value.type === 'VIDEO') {
            return PortfolioVideoToJSON(value as PortfolioVideo);
        }
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'profileId': value['profileId'],
        'index': value['index'],
        'type': ItemTypeToJSON(value['type']),
    };
}

